export enum BonusStatus {
  Pending = 'pending', // No action from Player and not claimed
  Active = 'active', // Successfully claimed
  Expired = 'expired', // Expiry date reached and player didn't claim
  Wagered = 'wagered', // Bonus is exhausted
  Cancelled = 'cancelled', // Cancel action from operator
}

export enum CampaignStatus {
  Created = 'created',
  InPrgress = 'in_progress',
  Given = 'given',
  Cancelled = 'cancelled',
  Completed = 'completed',
}

export enum BonusApiStatus {
  Success = 'success',
  Error = 'error',
}

export enum BonusAckType {
  Ignore = 'ignore',
  Cancel = 'cancel',
  Wager = 'wager',
  Expire = 'expire',
}
